/**
 * Created by adas27 on 11/11/2016.
 */

(function(window, Rayban, undefined){

    Rayban.storage = (function(){
        if(window.browserLocalObject === undefined){
            window.browserLocalObject = {};
        }
        var storeType = sessionStorage,
            stringify = function(obj) {
                return obj === undefined || typeof obj === "function" ? obj+'' : JSON.stringify(obj);
            },
            parse = function(str) {
                try{
                    return JSON.parse(str);
                }
                catch(e){
                    return str;
                }
            },
            isBrowserStorageSupported = function() 
            {
                try 
                {
                    storeType.setItem('testStorage', '1');
                    storeType.removeItem('testStorage');
                    return true;
                } 
                catch (error) 
                {
                    return false;
                }
            },
            options = {
                stringify: false
            };
        return {
            /**
             * Saves the data against a key.
             * @param {string} Key against which the data is saved.
             * @param {string | number | boolean | object} Data that needs to be saved.
             * @return {object} To be used incase the object needs to be stringified. Pass { stringify : true } into the save method
             */
            storageType: storeType,
            save: function(key, data, option){
                if(option){
                    options = option;
                }
                if(isBrowserStorageSupported()){
                    storeType.setItem(key, options.stringify? stringify(data) : data);
                }else{
                    browserLocalObject[key] = data;
                }
            },
            /**
             * Fetches the data mapped a key.
             * @param {string} Key against which the data is saved.
             * @return {object} To be used incase the object needs to be stringified. Pass { stringify : true } into the fetch method
             */
            fetch: function(key, option){
                if(option){
                    options = option;
                }
                if(isBrowserStorageSupported()){
                    return options.stringify? parse(storeType.getItem(key)) : storeType.getItem(key);
                }else{
                    return browserLocalObject[key];
                }
            },
            fetchAll: function(){
               if(isBrowserStorageSupported()){
                    return storeType;
                }else{
                    return browserLocalObject;
                }
            },
            remove: function(key){
                if(isBrowserStorageSupported()){
                    storeType.removeItem(key);
                }else{
                    delete browserLocalObject[key];
                }
            },
            removeAll: function(){
                if(isBrowserStorageSupported()){
                    storeType.clear();
                }else{
                    browserLocalObject = {};
                }
            }
        };
    }());

}(window, window.Rayban = window.Rayban || {}));